/**
 * Decide whether the seeded-account sign-in picker may render.
 * Local dev, beta, and alpha can show it. Production app hosts and the
 * production API stay on the normal email and password form.
 */

const VISIBLE_STAGES = new Set(["dev", "beta", "alpha"]);
const LOCAL_HOSTS = new Set(["localhost", "127.0.0.1", "::1", "[::1]"]);

/**
 * @param {string} [hostname]
 * @returns {boolean}
 */
function isProductionAttuneHost(hostname) {
  const host = String(hostname || "")
    .trim()
    .toLowerCase()
    .replace(/:\d+$/, "");

  if (!host || LOCAL_HOSTS.has(host)) return false;
  if (host === "attunelogic.com" || host === "www.attunelogic.com") return true;
  if (!host.endsWith(".attunelogic.com")) return false;

  const label = host.split(".")[0];
  return label !== "beta" && label !== "alpha";
}

/**
 * @param {string} [apiUrl]
 * @returns {boolean}
 */
function pointsAtProductionApi(apiUrl) {
  const value = String(apiUrl || "")
    .trim()
    .toLowerCase();

  if (!value) return false;

  return /(?:^|\/\/)api\.attunelogic\.com(?:[/:?#]|$)/.test(value);
}

/**
 * @param {{ stage?: string, hostname?: string, apiUrl?: string }} [input]
 * @returns {boolean}
 */
export function isDemoLoginPickerEnabled({ stage, hostname, apiUrl } = {}) {
  const normalizedStage = String(stage || "")
    .trim()
    .toLowerCase();

  if (!VISIBLE_STAGES.has(normalizedStage)) return false;
  if (isProductionAttuneHost(hostname)) return false;
  if (pointsAtProductionApi(apiUrl)) return false;

  return true;
}
